import React, { ReactNode, useRef } from 'react'
import {
  Heading,
  AlertDialog,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  IconButton,
  Box
} from '@chakra-ui/react'
import { X as XIcon } from '@components/icons'
import { ArrowLeftIcon } from '@blueprinthq/joy'
import { isMobile } from 'react-device-detect'

export const DialogContainer = ({
  children,
  onClose,
  isOpen,
  closeOnOverlayClick = true,
  isExtension = false
}: {
  children: ReactNode
  onClose: () => void
  isOpen: boolean
  closeOnOverlayClick?: boolean
  isExtension?: boolean
}) => {
  const closeRef = useRef(null)
  return (
    <AlertDialog
      closeOnOverlayClick={closeOnOverlayClick}
      motionPreset="slideInBottom"
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      leastDestructiveRef={closeRef}
      size={isExtension ? 'xs' : 'md'}
    >
      <AlertDialogOverlay />
      <AlertDialogContent
        borderRadius={16}
        display="flex"
        flexDirection="column"
        m={isMobile ? 6 : 0}
        p={isMobile ? 4 : 6}
      >
        {children}
      </AlertDialogContent>
    </AlertDialog>
  )
}

export const DialogActions = ({
  onClose,
  onBack
}: {
  onClose?: () => void
  onBack?: () => void
}) => {
  return (
    <AlertDialogHeader height={'180px'} p={0}>
      <Box
        display="flex"
        justifyContent={onBack ? 'space-between' : 'flex-end'}
        alignItems="center"
      >
        {onBack && (
          <IconButton
            display="flex"
            _focus={{ outline: 'none' }}
            variant="unstyled"
            icon={<ArrowLeftIcon fill="black" />}
            aria-label="Close"
            onClick={onBack}
          />
        )}
        {onClose && (
          <IconButton
            display="flex"
            _focus={{ outline: 'none' }}
            variant="unstyled"
            icon={<XIcon fill="black" />}
            aria-label="Close"
            onClick={onClose}
          />
        )}
      </Box>
    </AlertDialogHeader>
  )
}

export const DialogBody = ({ children }: { children: ReactNode }) => {
  return (
    <AlertDialogBody flex="1" p={1}>
      {children}
    </AlertDialogBody>
  )
}

export const DialogHeader = ({ text }: { text: string }) => {
  return (
    <Heading as="h3" fontSize="24px" textAlign="center">
      {text}
    </Heading>
  )
}

export const DialogFooter = ({ children }: { children: ReactNode }) => {
  return (
    <AlertDialogFooter
      height={'80px'}
      boxShadow="0px -4px 6px -1px rgba(0, 0, 0, 0.08), 0px -2px 4px -1px rgba(0, 0, 0, 0.08)"
    >
      {children}
    </AlertDialogFooter>
  )
}
